(() => {
  function init() {
    const filterRoot = document.querySelector(".education-filter");
    const cardsGrid = document.getElementById("education-cards");
    if (!filterRoot || !cardsGrid) return;

    const selectNiveau = document.getElementById("filter-niveau");
    const selectLesuren = document.getElementById("filter-lesuren");
    const selectWerkvorm = document.getElementById("filter-werkvorm");
    const resetButton = document.getElementById("filter-reset");
    const status = document.getElementById("filter-status");

    const cards = Array.from(cardsGrid.querySelectorAll(".education-card"));

    function getSelectedValue(select) {
      return select && select.value ? select.value.trim() : "";
    }

    function matches(card, attribute, value) {
      if (!value) return true;
      const attr = card.getAttribute(attribute) || "";
      const tokens = attr.split(/\s+/).filter(Boolean);
      return tokens.includes(value);
    }

    function announce(message) {
      if (!status) return;
      status.textContent = message;
    }

    function applyFilter() {
      const niveau = getSelectedValue(selectNiveau);
      const lesuren = getSelectedValue(selectLesuren);
      const werkvorm = getSelectedValue(selectWerkvorm);

      let visibleCount = 0;
      cards.forEach((card) => {
        const isVisible = matches(card, "data-niveau", niveau) && matches(card, "data-lesuren", lesuren) && matches(card, "data-werkvorm", werkvorm);
        card.style.display = isVisible ? "" : "none";
        if (isVisible) visibleCount += 1;
      });

      announce(`${visibleCount} ${visibleCount === 1 ? "opdracht" : "opdrachten"} gevonden`);
    }

    function resetFilters() {
      if (selectNiveau) selectNiveau.value = "";
      if (selectLesuren) selectLesuren.value = "";
      if (selectWerkvorm) selectWerkvorm.value = "";
      applyFilter();
      if (selectNiveau) selectNiveau.focus();
    }

    [selectNiveau, selectLesuren, selectWerkvorm].forEach((el) => {
      if (el) el.addEventListener("change", applyFilter);
    });

    if (resetButton) resetButton.addEventListener("click", resetFilters);

    announce(`${cards.length} ${cards.length === 1 ? "opdracht" : "opdrachten"} gevonden`);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
